import { Space, Tag, Tooltip } from "antd"
import { Button } from "src/components/actions/button"
import { PencilSvg } from "src/components/Svg"
import styled from "styled-components"
import {SolutionOutlined} from "@ant-design/icons";
import moment from "moment/moment";

export function getColumns(onEdit, categories = []) {
  const categoryLabels = Object.fromEntries(
      categories.map((category) => [category.value, category.label])
  )

  return [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Дата и время отправки",
      dataIndex: "availableAt",
      key: "availableAt",
      render: (text) => (
          <span>{ moment(text).format("YYYY-MM-DD  HH:mm:ss")}</span>
      ),
      sorter: (a, b) => a.availableAt - b.availableAt,
      defaultSortOrder: "ascend",
    },

    {
      title: "Заголовок",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Тело сообщения",
      dataIndex: "body",
      key: "body",
    },
    {
      title: "Категория",
      dataIndex: "notificationCategory",
      key: "notificationCategory",
      render: (slug) => (
          // У рассылок, созданных до появления категорий, поле пустое.
          <span>{slug ? (categoryLabels[slug] ?? slug) : "—"}</span>
      ),
    },
    {
      title: "Пользователей",
      dataIndex: "totalCountUser",
      key: "totalCountUser",
      render: (text) => (
          <StyledTag>{text}</StyledTag>
      ),
    },
    {
      title: "Доставили",
      dataIndex: "deliveredCountUser",
      key: "deliveredCountUser",
      render: (text) => (
          <StyledTag>{text}</StyledTag>
      ),
    },

    ...(onEdit ? [{
      title: "Действие",
      key: "action",
      render: (_, record) => (
          <Space size="small">
            <Tooltip placement="top" title="Подробнее" mouseLeaveDelay={0}>
              <Button size="small" type="link" onClick={() => onEdit(record.id)}>
                <SolutionOutlined style={{ fontSize: "16px" }} />
              </Button>
            </Tooltip>
          </Space>
      ),
    }] : []),
  ]
}

const StyledTag = styled(Tag)`
  font-weight: 600;
  text-transform: uppercase;
`